(() => {
  const READY_CLASS = 'kaching-bundles-ready';
  const HAS_CLASS = 'has-kaching-bundles';
  const FALLBACK_MS = 6000;
  const html = document.documentElement;
  let settled = false;

  const hasDealSettings = () =>
    !!document.querySelector('script.kaching-bundles-deal-block-settings');

  const widgetPainted = () =>
    !!document.querySelector('.kaching-bundles__bar, kaching-bundles-block .kaching-bundles');

  const markHasBundles = () => {
    if (hasDealSettings()) html.classList.add(HAS_CLASS);
  };

  const markReady = () => {
    if (settled) return;
    settled = true;
    html.classList.add(READY_CLASS);
    if (!widgetPainted()) html.classList.remove(HAS_CLASS);
    document.querySelectorAll('.pdp-bundle-skeleton').forEach((node) => node.remove());
  };

  const start = () => {
    markHasBundles();

    if (!html.classList.contains(HAS_CLASS)) {
      markReady();
      return;
    }

    if (widgetPainted()) {
      markReady();
      return;
    }

    window.addEventListener('kaching-bundles-initialized', markReady, { once: true });

    const observer = new MutationObserver(() => {
      markHasBundles();
      if (widgetPainted()) {
        observer.disconnect();
        markReady();
      }
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
    window.setTimeout(() => {
      observer.disconnect();
      markReady();
    }, FALLBACK_MS);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
